var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":"M0,0,4,4,8,0","transform":"translate(1.414 1.414)","fill":"none","stroke":"#97b0a9","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }